import http from '@plugins/axios';
import { getDeepObj } from '@utils/format';

export const state = () => ({
  loggedAs: null,
  id: null,
  operator: null,
  preferensi: null,
  included: null,
  is_tnk: null,
});

export const mutations = {
  SET_OPERATOR(state, newValue) {
    state.operator = newValue;
  },
  SET_ID(state, newValue) {
    state.id = newValue;
  },
  SET_LOGGED_AS(state, newValue) {
    state.loggedAs = newValue;
  },
  SET_PREFERENSI(state, newValue) {
    state.preferensi = newValue;
  },
  SET_INCLUDED(state, newValue) {
    state.included = newValue;
  },
  SET_TNK(state, newValue) {
    state.is_tnk = newValue;
  },
};

export const getters = {
  akseses(state) {
    return getDeepObj(state.preferensi, 'permissions') || {};
  },

  preference(state) {
    return state.preferensi;
  },

  langganan(state) {
    return state.langganan;
  },
};

export const actions = {
  async getPreferensi({ state, commit }, reset) {
    if (state.preferensi !== null && !reset) return Promise.resolve(state.preferensi);
    const rawData = await http.get('/preferensi').then(({ data }) => data);
    const preferensi = rawData.data;
    const included = rawData.included;
    const isTnk = [3, 5].includes(Number(preferensi?.akun?.attributes?.tenant_id ?? 0));
    // set
    commit('SET_PREFERENSI', preferensi);
    commit('SET_TNK', isTnk);
    commit('SET_INCLUDED', included);
    return Promise.resolve(preferensi);
  },

  setloginAs({ commit }, { id, operator, as }) {
    commit('SET_ID', id);
    commit('SET_OPERATOR', operator);
    commit('SET_LOGGED_AS', as);
  },
};
